export interface Video {
  description: string;
  videoId: string;
  startSeconds?: number;
  endSeconds?: number;
}

export const trumpVideos: Video[] = [
  {
    description: "I love women, but Arnold Palmer had a big thingy",
    videoId: "diw3aKjDJKg",
    startSeconds: 675,
  },
  {
    description:
      "Showing classified military plans to attack Iran to a reporter",
    videoId: "inVJF0Dr8mo",
    startSeconds: 48,
    endSeconds: 169,
  },
  {
    description:
      "I'm the father of IVF, but didn't know what it was until 8 months ago when a 'fantastically attracive' senator explained it to me",
    videoId: "aF23yXq_bc4",
    startSeconds: 106,
    endSeconds: 205,
  },
  {
    description:
      "If an electric boat is sinking, do you choose to get electrocuted or eaten by a shark?",
    startSeconds: 64,
    endSeconds: 119,
    videoId: "dh_Fo8XoS1A",
  },
  {
    description: "I have a better beach body than Sleepy Joe",
    videoId: "-Isn2i8vm9Y",
  },
  {
    description: "I said 'no way' to Vladimir Putin",
    videoId: "b4b9Ong-URI",
    startSeconds: 28,
    endSeconds: 43,
  },
  {
    description: "They're eating the dogs!  They're eating the cats!",
    videoId: "5llMaZ80ErY",
  },
  {
    description: "We are not weird!  We are solid rocks!",
    videoId: "99voxHFauCg",
    startSeconds: 470,
    endSeconds: 488,
  },
  {
    description: "Says Kamala Harris and Joe Biden are mentally impaired",
    videoId: "D08VJRB0_lM",
  },
  {
    description: "Trump suggests the plot to 'The Purge'",
    videoId: "ebIo3qDNbq0",
    startSeconds: 258,
    endSeconds: 274,
  },
  {
    description: "Nobody knows what the hell a phone app is",
    videoId: "ebIo3qDNbq0",
    startSeconds: 452,
    endSeconds: 471,
  },
  {
    description:
      "Friends of mine that are like English professors say \"it's the most brilliant thing I've ever seen\"",
    videoId: "GPcPlTQ8Vto",
    startSeconds: 541,
    endSeconds: 575,
  },
  {
    description:
      "Public schools take children and give them sex changes without their parents knowing",
    videoId: "0D9vp8y66xY",
    startSeconds: 540,
    endSeconds: 568,
  },
  {
    description: "I have concepts of a plan",
    videoId: "Z8xUH6HdNYs",
    startSeconds: 91,
  },
  {
    description: "Could we inject a disinfectant to cure Covid?",
    videoId: "N0eDaYt413g",
  },
  {
    description: "I have every part of your body",
    videoId: "GPcPlTQ8Vto",
    startSeconds: 111,
    endSeconds: 125,
  },
  {
    description: "Women: 'You will no longer be abandoned, lonely, or scared'",
    videoId: "lLB0wdfyc4g",
    startSeconds: 1,
    endSeconds: 83,
  },
  {
    description: "Calls Tim Cook, CEO of Apple, 'Tim Apple'",
    videoId: "XHVxm12NbrY",
  },
  {
    description: "Covid will miraculously disappear",
    videoId: "r8yOv4PwttM",
  },
  {
    description: "Kim Jong-un wrote me beautiful letters and we fell in love",
    videoId: "LV6mVmAVQU4",
  },
  {
    description: "Magnets don't work in water?",
    videoId: "rkIKEJPAUzM",
    startSeconds: 7,
    endSeconds: 12,
  },
  {
    description: "Windmills are killing whales",
    videoId: "NDncUKnk4R8",
  },
  {
    description: "The sound of windmills causes cancer",
    videoId: "WV66BlSoiLQ",
  },
];
